import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ProductTemplateService } from 'modules/inventory/settings/product-templates/services';
import { PRODUCT_TEMPLATE_LIST_KEY } from 'modules/inventory/settings/product-templates/constants';

export const useDeleteProductTemplate = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('productTemplates');
  return useMutation(() => ProductTemplateService.delete(id), {
    onSuccess: () => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries([PRODUCT_TEMPLATE_LIST_KEY]);
      queryClient.invalidateQueries([id]);
    },
  });
};
